import { render, staticRenderFns } from "./EnrollsDetails.vue?vue&type=template&id=20d4c234&scoped=true"
import script from "./EnrollsDetails.vue?vue&type=script&lang=js"
export * from "./EnrollsDetails.vue?vue&type=script&lang=js"
import style0 from "./EnrollsDetails.vue?vue&type=style&index=0&id=20d4c234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d4c234",
  null
  
)

export default component.exports